export const uxDesignerCollaborationSetup = {
  junior: {
    workflows: [
      'Join design team standups',
      'Participate in design critiques',
      'Learn design handoff process',
      'Shadow senior designers',
      'Set up design file organization'
    ],
    tools: ['Figma team setup', 'Slack channels', 'Design system access', 'Feedback tools'],
    processes: ['Design critique participation', 'File naming conventions', 'Version control basics']
  },
  mid: {
    workflows: [
      'Lead design critiques',
      'Mentor junior designers',
      'Cross-functional collaboration',
      'Design system contributions',
      'User research coordination'
    ],
    tools: ['Advanced Figma features', 'Prototyping tools', 'Research platforms', 'Analytics tools'],
    processes: ['Design review leadership', 'Cross-team communication', 'Research planning']
  },
  senior: {
    workflows: [
      'Design strategy planning',
      'Team process optimization',
      'Stakeholder management',
      'Design system governance',
      'Cross-functional leadership'
    ],
    tools: ['Strategic planning tools', 'Team management platforms', 'Executive dashboards'],
    processes: ['Strategic design planning', 'Team leadership', 'Process improvement']
  }
};
